import catalog from "./alphabetLetterNames.json";

export function buildVocabularySpellingAudioRefs(term: string, languageCode: string): string[] {
  const language = languageCode.toLowerCase() as keyof typeof catalog.languages;
  const names = catalog.languages[language] as Record<string, string> | undefined;
  if (!names) return [];
  const surface = term.normalize("NFC").toLocaleLowerCase(language === "tr" ? "tr-TR" : language)
    .replace(/[’`]/g, "'").replace(/-/g, " ")
    .replace(/[\u0610-\u061A\u0640\u064B-\u065F\u0670\u06D6-\u06ED]/gu, "")
    .replace(/\s+/g, " ").trim();
  const characters = Array.from(surface).filter((character) => character !== " ");
  if (!characters.length || characters.some((character) => !names[character])) return [];
  return characters.map((character) => `system/alphabet/${language}/letter_${character.codePointAt(0)!.toString(16)}.mp3`);
}
